import { getOneType } from '@/axios/api'

const oneType = {
  state: {
    oneType: []
  },
  mutations: {
    SET_ONETYPE (state, oneType) {
      state.oneType = oneType
    }
  },
  actions: {
    ONETYPE ({ commit }, params) {
      getOneType(params).then(res => {
        this.state.oneType = res.data.data
      })
    }
  }
}

export default oneType



// WEBPACK FOOTER //
// ./src/store/modules/getOneType.js